export default __webpack_public_path__ + "static/media/蔡欣穆.e362cddf.jpg";